<form
  class="form"
  [ngClass]="{ 'form--submitting': (formState | async) === 'SUBMITTING' }"
  [formGroup]="formGroup"
  [attr.name]="name"
  (ngSubmit)="submitForm()"
>
  @if ((formState | async) === 'SUBMITTING' && overlay) {
    <div class="form__submit-overlay" [ngClass]="{ 'form__submit-overlay--minimal': minimalOverlay }">
      <div class="form__overlay-soft-light" [@fade]></div>
      <div class="form__overlay-grey" [@halffade]></div>
    </div>
  }

  <ng-container *ngTemplateOutlet="formTemplate; context: { highlightErrors: highlightErrors }" />

  @if ((formState | async) === 'FAILURE' && submissionError) {
    <ftr-alert type="error" class="form__error block my-4" [renderAsMarkdown]="true">{{ submissionError }}</ftr-alert>
  }

  <div class="form__footer" [class.form__footer--left-aligned]="footerLeftAligned">
    <div class="form__footer__left-column" [class.form__footer__left-column--left-aligned]="footerLeftAligned">
      @if (preFormFooterTemplate) {
        <ng-container *ngTemplateOutlet="preFormFooterTemplate" />
      }
      @if (showGuard) {
        <ng-container
          *ngTemplateOutlet="
            submitGuardTemplate;
            context: { cancel: closeGuard.bind(this), submit: submitFormFromGuard.bind(this) }
          "
        />
      }
      @if (footerLeftAligned) {
        <ng-container *ngTemplateOutlet="submitButtonTemplate" />
        <ng-container *ngTemplateOutlet="formFooterTemplate" />
      } @else {
        <ng-container *ngTemplateOutlet="formFooterTemplate" />
        <ng-container *ngTemplateOutlet="submitButtonTemplate" />
      }
    </div>
    @if (formFooterRightTemplate) {
      <div class="form__footer__right-column">
        <ng-container *ngTemplateOutlet="formFooterRightTemplate" />
      </div>
    }
  </div>

  <div class="form__instructions">
    <ng-container *ngTemplateOutlet="formInstructionsTemplate" />
  </div>
</form>

<ng-template #submitButtonTemplate>
  @if (!hideSubmitButton && (formState | async); as formState) {
    <ftr-submit-button
      class="form__footer__submit"
      [class.form__footer__submit--full-width]="submitFullWidth || submitFullWidthMobile"
      [size]="submitSize"
      [highlightErrors]="highlightErrors"
      [formState]="formState"
      [submittingLabel]="submittingLabel"
      [submitLabel]="submitLabel"
      [direction]="submitDirection"
      [fullWidth]="submitFullWidth"
      [fullWidthMobile]="submitFullWidthMobile"
      [dataTrack]="trackSubmit"
      [color]="buttonColor"
    />
  }
</ng-template>
